/* Enova keepers landing pages. Native Shopify variants, cart and checkout stay authoritative. */
(() => {
  'use strict';
  const REGISTRY = {"skyhover-rc-helicopter": "enova-kp3-skyhover", "trackbot-robot-build-kit": "enova-kp3-trackbot", "harvesthaul-rc-tractor-set": "enova-kp3-harvesthaul", "pawdry-chenille-door-mat": "enova-kp3-pawdry"};
  const boot = () => {
    const root = document.querySelector('[data-kp-root]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = s => root.querySelector(s);
    const $$ = s => [...root.querySelectorAll(s)];
    const locale = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
    const endpoint = p => locale + p;
    const money = c => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(c / 100);
    const tell = (n, t) => { if (n) { n.textContent = t; n.hidden = !t; } };
    const previewId = window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : null;

    // Dialogs (policies + bag)
    const openDialog = d => { if (d && !d.open) { d.showModal(); document.body.classList.add('kp-modal-open'); } };
    $$('dialog').forEach(d => {
      d.addEventListener('close', () => { if (!document.querySelector('dialog[open]')) document.body.classList.remove('kp-modal-open'); });
      d.querySelectorAll('[data-close-dialog]').forEach(b => b.addEventListener('click', () => d.close()));
      d.addEventListener('click', e => { if (e.target === d) d.close(); });
    });
    root.addEventListener('click', e => { const b = e.target.closest('[data-policy]'); if (b) { e.preventDefault(); openDialog($('#kp-policy-' + b.dataset.policy)); } });
    // Keep shoppers on the landing page: storefront links inside policy text become plain text.
    $$('.kp-policy-content a').forEach(a => {
      try { const u = new URL(a.href, location.href); if (u.origin === location.origin && !u.pathname.startsWith('/policies/')) a.replaceWith(document.createTextNode(a.textContent)); } catch { /* keep */ }
    });

    const fetchJSON = async (path, opts = {}) => {
      const r = await fetch(endpoint(path), { credentials: 'same-origin', ...opts, signal: AbortSignal.timeout(18000) });
      if (!/^(application\/json|text\/javascript|application\/javascript)(;|$)/i.test(r.headers.get('content-type') || '')) throw new Error('Shopify could not load your bag. Please refresh and try again.');
      const d = await r.json();
      if (!r.ok) { const err = new Error(d.description || d.message || 'Shopify could not update your bag.'); err.status = r.status; throw err; }
      return d;
    };

    // Cart page (full bag view) only needs policies + return link.
    if (root.matches('[data-cart-page]')) {
      try { const back = sessionStorage.getItem('enova-kp3:last'); const u = back && new URL(back, location.origin); if (u && u.origin === location.origin && u.pathname.includes('/products/') && Object.hasOwn(REGISTRY, u.pathname.split('/').pop())) { const a = $('[data-return-pdp]'); a.href = u.href; a.hidden = false; } } catch { /* optional */ }
      return;
    }

    const handle = root.dataset.handle;
    if (!Object.hasOwn(REGISTRY, handle)) return;
    try { const u = new URL(location.href); u.hash = ''; sessionStorage.setItem('enova-kp3:last', u.href); } catch { /* optional */ }

    // Gallery
    const hero = $('[data-hero-image]');
    $$('[data-thumb]').forEach(b => b.addEventListener('click', () => {
      if (!hero) return;
      hero.removeAttribute('srcset'); hero.src = b.dataset.image; hero.alt = b.dataset.alt;
      const all = $$('[data-thumb]'); all.forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      tell($('[data-gallery-count]'), String(all.indexOf(b) + 1).padStart(2, '0') + ' / ' + String(all.length).padStart(2, '0'));
    }));

    // Honest session clock: counts this visit's session only, persists, stops at 00:00. The sale price does not expire.
    (() => {
      const clocks = $$('[data-session]'); if (!clocks.length) return;
      const key = 'enova-kp3:session:' + (window.Shopify?.theme?.id || 'x') + ':' + handle;
      let deadline;
      try { deadline = Number(localStorage.getItem(key)); if (!deadline || deadline < Date.now() - 864e5) { deadline = Date.now() + 15 * 60e3; localStorage.setItem(key, String(deadline)); } } catch { return; }
      const pad = n => String(n).padStart(2, '0');
      const tick = () => {
        const left = Math.max(0, deadline - Date.now()); const s = Math.floor(left / 1000);
        $$('[data-session-clock]').forEach(n => n.textContent = pad(Math.floor(s / 60)) + ':' + pad(s % 60));
        if (!left) clearInterval(t);
      };
      clocks.forEach(c => c.hidden = false); tick(); const t = setInterval(tick, 1000);
    })();

    // Variant selection: bundle (+ optional size) → exact native variant id.
    const form = $('#kp-product-form');
    const variants = JSON.parse($('[data-kp-variants]')?.textContent || '[]');
    const purchasable = root.dataset.purchasable === 'true';
    const sized = root.dataset.sized === 'true';
    let selected = null, busy = false, uncertain = false, latestCart = null, lastColor = null;
    const colored = root.dataset.colored === 'true';
    const pick = (bundle, size, color) => variants.find(v => v.options.includes(bundle) && (!sized || v.options.includes(size)) && (!colored || v.options.includes(color)));
    const setBusy = v => {
      busy = v;
      $$('[data-add-button]').forEach(b => b.disabled = v || uncertain || !purchasable || !selected?.available);
      $$('[data-cart-quantity],[data-cart-remove],[data-checkout]').forEach(b => b.disabled = v || uncertain || (b.hasAttribute('data-checkout') && !latestCart?.item_count));
      root.setAttribute('aria-busy', String(v));
    };
    const paint = () => {
      if (!form) return;
      const bundle = form.querySelector('[data-bundle-input]:checked')?.value || 'Buy 1';
      const size = form.querySelector('[data-size-input]:checked')?.value;
      const color = form.querySelector('[data-color-input]:checked')?.value;
      selected = pick(bundle, size, color);
      if (!selected) { setBusy(busy); return; }
      form.querySelector('[data-variant-id]').value = String(selected.id);
      tell($('[data-size-name]'), size || '');
      tell($('[data-color-name]'), color || '');
      if (colored && selected.featured_image && hero && lastColor !== color) { lastColor = color; hero.removeAttribute('srcset'); hero.src = selected.featured_image.src + (selected.featured_image.src.includes('?') ? '&' : '?') + 'width=1400'; hero.alt = selected.featured_image.alt || hero.alt; $$('[data-thumb]').forEach((x, i) => x.setAttribute('aria-pressed', String(i === 0))); }
      ['Buy 1', 'Buy 2', 'Buy 3'].forEach((b, i) => {
        const v = pick(b, size, color); if (!v) return; const n = i + 1;
        $$(`[data-bundle-price="${n}"]`).forEach(x => x.textContent = money(v.price));
        $$(`[data-bundle-compare="${n}"]`).forEach(x => x.textContent = v.compare_at_price ? money(v.compare_at_price) : '');
        $$(`[data-bundle-each="${n}"]`).forEach(x => x.textContent = money(Math.floor(v.price / n)));
      });
      $$('[data-price]').forEach(x => x.textContent = money(selected.price));
      $$('[data-compare]').forEach(x => x.textContent = selected.compare_at_price ? money(selected.compare_at_price) : '');
      const pct = selected.compare_at_price > selected.price ? Math.round((1 - selected.price / selected.compare_at_price) * 100) : 0;
      $$('[data-save]').forEach(x => { x.textContent = pct ? 'Save ' + pct + '%' : ''; x.hidden = !pct; });
      $$('[data-cta-price]').forEach(x => x.textContent = money(selected.price));
      $$('[data-sticky-price]').forEach(x => x.textContent = money(selected.price) + (pct ? ' · ' + pct + '% off' : ''));
      tell($('[data-add-label]'), selected.available || !purchasable ? 'Add to bag' : 'Sold out');
      const u = new URL(location.href); u.searchParams.set('variant', selected.id); history.replaceState(null, '', u);
      setBusy(busy);
    };
    if (form) {
      // Honor a ?variant= deep link.
      const want = new URL(location.href).searchParams.get('variant');
      const dv = want && variants.find(v => String(v.id) === want);
      if (dv) {
        dv.options.forEach(o => { form.querySelectorAll(`[data-bundle-input][value="${CSS.escape(o)}"],[data-size-input][value="${CSS.escape(o)}"],[data-color-input][value="${CSS.escape(o)}"]`).forEach(i => i.checked = true); });
      }
      form.addEventListener('change', paint); paint();
    }

    // Sticky bar after the main CTA scrolls away.
    const sticky = $('[data-sticky]'), mainCta = form?.querySelector('[data-add-button]');
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => { const show = !e.isIntersecting && e.boundingClientRect.top < 0; sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', String(!show)); sticky.querySelector('button').tabIndex = show ? 0 : -1; }).observe(mainCta);
    }
    $$('[data-scroll-buy]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); $('#kp-buy')?.scrollIntoView({ behavior: 'smooth', block: 'start' }); }));

    // Bag drawer
    const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text !== undefined) n.textContent = text; return n; };
    const renderCart = cart => {
      latestCart = cart;
      $$('[data-cart-count]').forEach(n => n.textContent = String(cart.item_count));
      $$('[data-cart-total]').forEach(n => n.textContent = money(cart.total_price));
      const list = $('[data-cart-items]'); if (!list) return;
      list.replaceChildren();
      if (!cart.item_count) list.append(el('p', 'kp-cart-empty', 'Your bag is empty.'));
      cart.items.forEach(item => {
        const row = el('article', 'kp-cart-item');
        if (item.image) { const i = el('img'); i.src = item.image; i.alt = item.product_title; i.width = 84; i.height = 84; row.append(i); }
        const c = el('div'); c.append(el('h3', '', item.product_title));
        if (item.variant_title && item.variant_title !== 'Default Title') c.append(el('p', '', item.variant_title));
        const price = el('strong', '', money(item.final_line_price));
        c.append(price);
        const q = el('div', 'kp-cart-qty');
        [[-1, '−'], [1, '+']].forEach(([d, l], i) => { const b = el('button', '', l); b.type = 'button'; b.dataset.cartQuantity = String(d); b.dataset.key = item.key; b.setAttribute('aria-label', (d < 0 ? 'Decrease ' : 'Increase ') + item.product_title + ' quantity'); if (i) q.append(el('output', '', String(item.quantity))); q.append(b); });
        const rm = el('button', 'kp-remove', 'Remove'); rm.type = 'button'; rm.dataset.cartRemove = item.key;
        c.append(q, rm); row.append(c); list.append(row);
      });
      $$('[data-cart-discounts]').forEach(n => n.textContent = (cart.cart_level_discount_applications || []).map(d => d.title + ': −' + money(d.total_allocated_amount)).join(' · '));
      $$('[data-checkout]').forEach(b => b.disabled = busy || uncertain || !cart.item_count);
    };
    const readCart = async () => { const c = await fetchJSON('/cart.js'); renderCart(c); return c; };
    const showCart = async () => {
      openDialog($('.kp-cart-dialog')); if (busy || uncertain) return;
      setBusy(true); tell($('[data-cart-status]'), '');
      try { await readCart(); } catch (e) { tell($('[data-cart-status]'), e.message); } finally { setBusy(false); }
    };
    $$('[data-open-cart]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); showCart(); }));
    root.addEventListener('click', async e => {
      const b = e.target.closest('[data-cart-quantity],[data-cart-remove]'); if (!b || busy || uncertain) return;
      const key = b.dataset.key || b.dataset.cartRemove; const item = latestCart?.items.find(i => i.key === key); if (!item) return;
      const quantity = b.hasAttribute('data-cart-remove') ? 0 : item.quantity + Number(b.dataset.cartQuantity);
      setBusy(true);
      try { renderCart(await fetchJSON('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) })); tell($('[data-cart-status]'), ''); }
      catch (err) { try { await readCart(); tell($('[data-cart-status]'), err.message); } catch { uncertain = true; tell($('[data-cart-status]'), 'Unable to verify your bag. Please refresh.'); } }
      finally { setBusy(false); }
    });
    form?.addEventListener('submit', async e => {
      e.preventDefault(); if (busy || uncertain || !purchasable || !selected?.available) return;
      const requested = String(selected.id); const data = new FormData(form); data.delete('return_to');
      setBusy(true); tell($('[data-form-error]'), ''); let added = false;
      try {
        await fetchJSON('/cart/add.js', { method: 'POST', body: data }); added = true;
        const cart = await readCart();
        if (!cart.items.some(i => String(i.variant_id) === requested && i.quantity > 0)) throw new Error('Shopify did not confirm the selected item.');
        openDialog($('.kp-cart-dialog'));
      } catch (err) {
        try { await readCart(); } catch { uncertain = true; }
        if (added || ![400, 422].includes(err.status)) uncertain = true;
        tell($('[data-form-error]'), err.message + (uncertain ? ' Check your bag before adding again.' : ''));
      } finally { setBusy(false); }
    });
    $$('[data-native-checkout-form]').forEach(f => f.addEventListener('submit', async e => {
      if (!e.submitter?.matches('[data-checkout]')) return;
      e.preventDefault(); if (busy || uncertain) return; setBusy(true);
      try { const c = await readCart(); if (!c.item_count) throw new Error('Your bag is empty.');
        const i = document.createElement('input'); i.type = 'hidden'; i.name = 'checkout'; i.value = 'Checkout'; f.append(i);
        HTMLFormElement.prototype.submit.call(f);
      } catch (err) { tell($('[data-cart-status]'), err.message); setBusy(false); }
    }));
    fetchJSON('/cart.js').then(c => { if (busy || latestCart) return; latestCart = c; $$('[data-cart-count]').forEach(n => n.textContent = String(c.item_count)); }).catch(() => {});
    void previewId;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})();
